// src/context/GeoContext.js
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from '../modules/Base/Auth/contexts/AuthContext'; // или откуда у вас берётся роль

const GeoContext = createContext({
  geoEnabled: false,
  setGeoEnabled: () => {}   // <— убрали TypeScript-тип
});


export function GeoProvider({ children }) {
  const { user } = useAuth();          // предполагаем, что в user.role лежит строка роли
  const isCourier = user?.role === 'Courier';

  // Инициализируем флаг: если курьер — true, иначе false
  const [geoEnabled, setGeoEnabledState] = useState(() => isCourier);

  // Если роль поменялась на Courier — включаем гео автоматически
  useEffect(() => {
    if (isCourier && !geoEnabled) {
      setGeoEnabledState(true);
    }
  }, [isCourier, geoEnabled]);

  // Оборачиваем сеттер, чтобы курьер не мог его вручную выключить
  const setGeoEnabled = useCallback((enabled) => {
    if (isCourier) {
      // для курьера всегда true, игнорируем попытки выключить
      setGeoEnabledState(true);
    } else {
      setGeoEnabledState(enabled);
    }
  }, [isCourier]);

  return (
    <GeoContext.Provider value={{ geoEnabled, setGeoEnabled }}>
      {children}
    </GeoContext.Provider>
  );
}

export function useGeo() {
  return useContext(GeoContext);
}
